<template>
  <div @click="handleClick" :class="['concept-style', 'concept-summary']" :id="concept.id">
    <div class="identifiers">
      <h3>{{concept.name}}</h3>
      <p>{{description}}</p>
      <p class="faded">{{ ideaCountLabel }} &nbsp; &nbsp; {{ referenceCountLabel }}</p>
    </div>
    <div class="collage">
      <div class="blocks">
        <Block
          v-for="(block, index) in collageBlocks"
          v-bind:block="block"
          v-bind:index="index"
          v-bind:key="block.id"
          v-bind:viewActions="false"
          small="small"
          v-bind:inConceptId="this.concept.id"
        ></Block>
      </div>
    </div>
    <!--<div class="concept__shadows">
      <div class="concept__shadows-inner"></div>
      <div class="concept__shadows-outer"></div>
    </div>-->
  </div>
</template>

<script>
import Block from '@trust/components/Block.vue'

export default {
  name: 'ConceptSummary',
  components: {
    Block,
  },
  props: ['concept', 'index', 'id'],
  data(){
    return {
      opacityDelta: 0.1,
      yDelta: 24,
      zDelta: 10,
      scaleDelta: 0.1,
    }
  },
  computed: {
    ideaCountLabel(){
      let ideaBlocks = [];
      if(this.$store.state.org.blocks){
        ideaBlocks = this.$store.state.org.blocks.filter(function(block){
          if(block.concepts) {
            return block.concepts.includes(this.concept.id) && (block.type == 'Idea' || block.type == undefined);
          }

          return false;
        }.bind(this));
      }

      let label = ideaBlocks.length + ' Idea';
      if(ideaBlocks.length > 1) { label += 's'}
      return label;
    },
    referenceCountLabel(){
      let refBlocks = [];
      if(this.$store.state.org.blocks){
        refBlocks = this.$store.state.org.blocks.filter(function(block){
          if(block.concepts) {
            return block.concepts.includes(this.concept.id) && (block.type == 'Reference');
          }

          return false;
        }.bind(this));
      }

      let label = refBlocks.length + ' Reference';
      if(refBlocks.length > 1) { label += 's'}
      return label;
    },
    description(){
      return this.concept.description || "No description"
    },
    collageBlocks(){

      let allBlocks = [];
      if(this.$store.state.org.blocks){
        allBlocks = this.$store.state.org.blocks.filter(function(block){
          if(block.concepts) {
            return block.concepts.includes(this.concept.id) && (block.type == 'Idea' || block.type == undefined);
          }

          return false;
        }.bind(this));

        allBlocks.sort(function(a, b) {
          if (a.createdAt > b.createdAt) return -1;
          if (a.createdAt < b.createdAt) return 1;
          return 0;
        });
      }

      let threeBlocks = [];
      for(let i = 0; i < 3; i++){
        if(allBlocks[i]){
          threeBlocks.push(allBlocks[i]);
        }
      }
      return threeBlocks;

    }
  },
  methods: {
    handleClick(){
      this.$store.dispatch('closeLeftAndRight');
      this.$emit('goToConcept');
    },
  },
  mounted () {
  }
}
</script>

<style>
  .concept-summary {
    display: grid;
    grid-template-columns: 1fr 100px;
    padding: 10px;
    padding-right: 2px;
    border-radius: 12px;
    margin-bottom: 10px;
  }

  .concept-summary p {
    font-size: 0.8rem;
    line-height: 150%;
    margin: 0;
  }

  .concept-summary .faded {
    color: var(--beige-700);
    margin-top: 4px;
  }

  .concept-summary .collage {
    width: 100%;
    max-height: 97px;
    overflow: hidden;
  }

  .concept-summary .collage .blocks {
    display: flex;
    float: left;
    /* display: grid; */
    /* grid-template-columns: 1fr 1fr 1fr; */
    /* grid-gap: 0px; */
    /* margin-left: 0; */
  }

  .concept-summary .collage .blocks .block {
    width: 45px;
    padding: 0;
    overflow: hidden;
  }

  .concept-summary .collage .blocks .box {
    border: 2px solid var(--beige-200);
    width: 100%;
  }

  .concept-summary .collage .blocks p {
    font-size: 7px;
    max-height: 40px;
    overflow: hidden;
  }

  .concept-summary .collage .blocks .title {
    display: none;
  }

  .concept-summary .collage .blocks .block:nth-child(1) {
    transform: translate(10px,18px);
  }

  .concept-summary .collage .blocks .block:nth-child(3) {
    transform: translate(-5px,5px);
    z-index: -10;
  }

</style>
